export default __webpack_public_path__ + "static/media/puffer-fish.fbea6fc5.png";